import { Component, OnInit, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Documents } from 'src/app/enums/documents.enums';
import { Ranges } from 'src/app/enums/ranges.enum';
import { States } from 'src/app/enums/states.enum';
import { Countries } from 'src/app/mocks/country.data';
import { AdminService } from 'src/app/services/admin.service';
import { StoreService } from 'src/app/services/store.service';
import { AlertComponent } from '../alert/alert.component';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-asesor-register',
  templateUrl: './asesor-register.component.html',
  styleUrls: ['./asesor-register.component.scss']
})
export class AsesorRegisterComponent implements OnInit {
  ranges: any[] = [];
  documents: any[] = [];
  countries: any[] = [];
  rol: number = 0;
  asesorForm!: FormGroup;
  loader: boolean = false;
  plans: any[] = [];
  hasSpecialPermits: boolean = false;

  constructor(
    private storeservice: StoreService,
    private adminservice: AdminService,
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<AsesorRegisterComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    this.rol = +this.storeservice.getProfile.rol_id;
    //this.ranges = Ranges;
    //this.documents = Documents;
    this.getCountries();
    this.getRanges();
    this.getDocuments();
    this.getPlans();
    this.formBuilder();

    this.asesorForm.get('permits')?.valueChanges.subscribe(value => {
      this.hasSpecialPermits = value;
      const plansControl = this.asesorForm.get('plans');
      if (value) {
        plansControl?.setValidators(Validators.required);
      } else {
        plansControl?.clearValidators();
        plansControl?.setValue(null);
      }
      plansControl?.updateValueAndValidity();
    });

    if (this.data?.userId > 0) {
      this.asesorForm.patchValue(this.data, { emitEvent: true });
    }
  }

  formBuilder() {
    this.asesorForm = new FormGroup({
      userId: new FormControl(0, Validators.required),
      fullname: new FormControl('', Validators.required),
      country: new FormControl('', Validators.required),
      city: new FormControl('', Validators.required),
      address: new FormControl(''),
      phone: new FormControl(''),
      email: new FormControl('', [Validators.required, Validators.email]),
      fecnac: new FormControl(null),
      range: new FormControl(''),
      typeDoc: new FormControl(''),
      numberDocument: new FormControl(''),
      plans: new FormControl(null),
      permits: new FormControl(false)
    });
  }

  getCountries() {
    this.adminservice.getCountries().subscribe(
      (response) => {
        if (response.rtn && response.result) {
          this.countries = response.result;
        }
      }
    );
  }

  getRanges() {
    this.adminservice.getRanges().subscribe(
      (response) => {
        if (response.rtn && response.result) {
          this.ranges = response.result;
        }
      }
    );
  }

  getDocuments() {
    this.adminservice.getDocuments().subscribe(
      (response) => {
        if (response.rtn && response.result) {
          this.documents = response.result;
        }
      }
    );
  }

  getPlans(): void {
    this.adminservice.getPlans().subscribe(response => response.rtn && response.result ? this.plans = response.result : []);
  }

  saveUser() {

    if (!this.asesorForm.valid) {
      return
    }

    let fecPattern = /^\d{2}\/\d{2}\/\d{4}$/;
    if (!fecPattern.test(this.asesorForm.value.fecnac) && this.asesorForm.value.fecnac) {
      this.dialog.open(AlertComponent, {
        width: '776px',
        disableClose: true,
        data: {
          type: 'success',
          title: 'Mensaje del sistema',
          description: 'La fecha de nacimiento debe contener el formato dd/mm/aaaa. Corrija el campo por favor',
          textButton: 'Entendido'
        }
      });
      return
    }

    const request = {
      "usuario_id": this.asesorForm.value.userId,
      "nombre": this.asesorForm.value.fullname,
      "apellido": " ",
      "correo": this.asesorForm.value.email,
      "pais_id": this.asesorForm.value.country,
      "ciudad": this.asesorForm.value.city,
      "direccion": this.asesorForm.value.address,
      "nro_telefono": this.asesorForm.value.phone,
      "fec_nacimiento": this.asesorForm.value.fecnac ? `${this.asesorForm.value.fecnac.split('/')[2]}-${this.asesorForm.value.fecnac.split('/')[1]
        }-${this.asesorForm.value.fecnac.split('/')[0]}` : '',
      "tipo_documento": this.asesorForm.value.typeDoc,
      "nro_documento": this.asesorForm.value.numberDocument,
      "rango_id": this.asesorForm.value.range,
      "plan_id": this.asesorForm.value.plans,
      "perm_especial": this.asesorForm.value.permits
    }

    this.loader = true;
    this.adminservice.saveUser(request, null).subscribe(
      (response) => {
        this.loader = false;
        if (response.rtn && response.result > 0) {
          this.dialogRef.close(true);
          this.dialog.open(AlertComponent, {
            width: '776px',
            disableClose: true,
            data: {
              type: 'success',
              title: 'Registro exitoso',
              description: 'Se ha creado el asesor correctamente. Sus credenciales fueron enviadas a su correo.',
              textButton: 'Entendido'
            }
          });
        }
      }
    );

  }

  keypressNumbers(event: any) {
    const pattern = /[0-9]/;
    const inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

}
